import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from '../privateRoute';
import LoginPage from '../../pages/login';
import CampaignPage from '../../pages/campaign';
import CampaignArchivedPage from '../../pages/campaign/archived';
import CampaignDetailPage from '../../pages/campaign/[campaignId]';
import SettingsPage from '../../pages/settings';
import OnboardingPage from '../../pages/onboarding';

export const URL_PATHNAMES = {
  HOME: '/home',
  LOGIN: '/login',
  CAMPAIGN: '/campaign',
  SETTINGS: '/settings',
  ONBOARDING: '/onboarding'
};

/**
 * Where to send the user after Stytch login once `useUserInitialization` has populated context.
 * Only `discovery` is the new-user / org-discovery handoff. `discovery_oauth` is used for normal
 * Google/Microsoft OAuth via discovery_redirect_url — those users should go to campaign.
 */
export function getPostLoginPath(stytch_token_type: string): string {
  if (stytch_token_type === 'discovery') {
    return URL_PATHNAMES.ONBOARDING;
  }
  return URL_PATHNAMES.CAMPAIGN;
}

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => (
  <PrivateRoute>{children}</PrivateRoute>
);

interface AppRoutesProps {
  isAdmin?: boolean;
}

export const AppRoutes = ({ isAdmin }: AppRoutesProps) => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path={URL_PATHNAMES.LOGIN} element={<LoginPage />} />

      {/* Campaign routes without sidebar */}
      <Route
        path="/campaign"
        element={
          <ProtectedRoute>
            <CampaignPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/campaign/archived"
        element={
          <ProtectedRoute>
            <CampaignArchivedPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/campaign/:campaignId"
        element={
          <ProtectedRoute>
            <CampaignDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={URL_PATHNAMES.SETTINGS}
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={URL_PATHNAMES.ONBOARDING}
        element={
          <ProtectedRoute>
            <OnboardingPage />
          </ProtectedRoute>
        }
      />

      {/* Catch-all route */}
      <Route path="*" element={<Navigate to={URL_PATHNAMES.LOGIN} replace />} />
    </Routes>
  );
};
